/**
 * The "Best estate, cashflow covered" tab when its leader IS the best estate outright.
 *
 * Owner, 24 Sep 2026: "you don't need to show the massive tile with all the output. You can simply
 * say really neatly 'same result as best estate — no plan leaves more' and just keep it nice and
 * neat at that." So: one small card, no figures, and a pointer to the tab that has them.
 */
import React from 'react';
import { CheckCircle2 } from 'lucide-react';
import { SAME_PLAN_NOTE } from '../../strategy/cashflowCoveredGoal.ts';

export function SameAsBestEstateNote({ onShowBestEstate }: { onShowBestEstate?: () => void }) {
    return (
        <div className="flex items-start gap-3 rounded-xl border border-slate-200/70 border-l-4 border-l-emerald-500 bg-white px-4 py-3.5 shadow-sm">
            <CheckCircle2 size={20} className="mt-0.5 shrink-0 text-emerald-600" aria-hidden="true" />
            <div className="min-w-0">
                <p className="text-[15px] font-semibold text-slate-900">{SAME_PLAN_NOTE}</p>
                <p className="mt-0.5 text-sm text-slate-600">
                    The plan that leaves the most also pays its way, so there is nothing separate to show here.{' '}
                    {onShowBestEstate ? (
                        <button type="button" onClick={onShowBestEstate} className="font-semibold text-blue-700 underline underline-offset-2 hover:text-blue-900">
                            See it under Best estate
                        </button>
                    ) : (
                        'See it under Best estate.'
                    )}
                </p>
            </div>
        </div>
    );
}

export default SameAsBestEstateNote;
